import { render, staticRenderFns } from "./userConfiguration.vue?vue&type=template&id=10793394&"
import script from "./userConfiguration.vue?vue&type=script&lang=js&"
export * from "./userConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports